/**
 * SyncService.js
 * 
 * Service for trigg 
 */
import axios from 'axios';
import { getApiBaseUrl, getAuthHeaders } from '../utils/urlConfig';

class SyncService {
  constructor() {
    this.apiBaseUrl = getApiBaseUrl();
  }

  /**
   * Trigger synchronization of all data types
   * @returns {Promise} - Resolves with sync result data
   */
  async syncAll() {
    try {
      const response = await axios.get(`${this.apiBaseUrl}/daily-sync/all`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error triggering full data sync:', error);
      throw error;
    }
  }

  /**
   * Trigger synchronization of a specific data type
   * @param {string} dataType - Type of data to synchronize
   * @returns {Promise} - Resolves with sync result data
   */
  async syncByType(dataType) {
    try {
      if (!dataType) {
        throw new Error('Data type is required');
      }
      
      const response = await axios.get(`${this.apiBaseUrl}/daily-sync/${dataType}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error(`Error triggering ${dataType} sync:`, error);
      throw error;
    }
  }

  /**
   * Check if a specific type of sync is currently running
   * @param {string} syncType - Type of sync to check
   * @returns {boolean} - True if sync is running
   */
  isSyncRunning(runningSyncs, syncType) {
    if (!runningSyncs || !Array.isArray(runningSyncs)) {
      return false;
    }
    
    return runningSyncs.some(sync => 
      sync.type === syncType && ['running', 'processing'].includes(sync.status)
    );
  }

  /**
   * Get details of a running sync by type
   * @param {Array} runningSyncs - Array of running syncs
   * @param {string} syncType - Type of sync to find
   * @returns {Object|null} - Sync details or null if not found
   */
  getRunningSyncByType(runningSyncs, syncType) {
    if (!runningSyncs || !Array.isArray(runningSyncs)) {
      return null;
    }
    
    return runningSyncs.find(sync => 
      sync.type === syncType && ['running', 'processing'].includes(sync.status)
    ) || null;
  }
}

const syncService = new SyncService();
export default syncService; 